import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { useStyle } from '@magento/venia-ui/lib/classify';
import defaultClasses from './designTeamMember.module.css';
import DesignMemberModal from './designMemberModal';
import { addScrollToBody, removeScrollFromBody } from '../../hooks/utils';

var DesignTeamMember = function DesignTeamMember(props) {
  var _props$member = props.member,
      first_name = _props$member.first_name,
      last_name = _props$member.last_name,
      position = _props$member.position,
      image = _props$member.image,
      image_hover = _props$member.image_hover,
      description = _props$member.description;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isModalOpen = _useState2[0],
      setIsModalOpen = _useState2[1];

  var handleCloseModal = function handleCloseModal() {
    return setIsModalOpen(false);
  };

  var handleModalOpen = function handleModalOpen() {
    return setIsModalOpen(true);
  };

  useEffect(function () {
    if (isModalOpen) removeScrollFromBody(false);else addScrollToBody(false);
    return function () {
      return addScrollToBody(false);
    };
  }, [isModalOpen]);
  var classes = useStyle(defaultClasses, props.classes);
  var fullName = first_name + ' ' + last_name;
  return React.createElement(React.Fragment, null, React.createElement(DesignMemberModal, {
    isOpen: isModalOpen,
    closeModal: handleCloseModal,
    member: props.member
  }), React.createElement("div", {
    className: "col-span-6 mb-6 lg_col-span-4 relative text-white"
  }, React.createElement("div", null, React.createElement("img", {
    src: image,
    alt: fullName,
    className: "object-cover h-auto"
  }), React.createElement("div", {
    className: classes.nameTextBox
  }, React.createElement("h6", {
    className: classes.nameText
  }, React.createElement("span", {
    className: classes.namePart
  }, first_name), React.createElement("span", {
    className: classes.namePart
  }, last_name)), React.createElement("p", {
    className: "text-xs text-white leading-6 sm_text-sm"
  }, position))), description && React.createElement("div", {
    className: classes.memberDescription,
    onClick: handleModalOpen
  }, React.createElement("div", {
    className: classes.hoverDescription
  }, React.createElement("img", {
    src: image_hover ? image_hover : image,
    alt: fullName,
    className: classes.teamMemberImage
  }), React.createElement("div", {
    className: "px-4 md_px-8 top-4 sm_top-10 left-0 absolute"
  }, React.createElement("h6", {
    className: "leading-8"
  }, fullName), React.createElement("p", {
    className: "text-xs text-white leading-6 pb-3 pt-3 sm_pt-7 uppercase font-bold sm_text-sm"
  }, position), React.createElement("p", {
    className: classes.memberHoverText
  }, description), React.createElement("p", {
    className: classes.learnMoreText
  }, "Learn More"))))));
};

export default DesignTeamMember;